exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.UISP-Screen {\n  display: inline-block;\n  padding: 20px;\n}\n.UISP-Screen svg.UISP-Screen__svgRoot {\n  display: block;\n  -webkit-transition: width 0.2s, height 0.2s;\n  transition: width 0.2s, height 0.2s;\n}\n.UISP-Screen--fit {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: 0;\n}\n.UISP-Screen--fit svg.UISP-Screen__svgRoot {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: block;\n  width: 100%;\n  max-height: calc(100vh - 48px - 30px);\n  margin: auto;\n  padding: 0;\n}\n.UISP-Screen--highlight .Screen_Highlight {\n  display: inline;\n}\n", ""]);

// exports
